/* Andara automatic gift: 2 x 4-pack OR 1 x 8-pack. No claim required. */
(() => {
  if (window.__andaraAutoGiftLoaded) return;
  window.__andaraAutoGiftLoaded = true;
  const configEl = document.querySelector('free-gift-config');
  if (!configEl || configEl.dataset.enabled !== 'true') return;
  const val = (name) => configEl.getAttribute(name) || '';
  const giftVariant = String(val('data-variant-id'));
  const aProduct = String(val('data-trigger-product-id'));
  const aVariant = String(val('data-trigger-variant-id'));
  const bProduct = String(val('data-trigger2-product-id'));
  const bVariant = String(val('data-trigger2-variant-id'));
  const aQty = Number(val('data-trigger-quantity')) || 2;
  const bQty = Number(val('data-trigger2-quantity')) || 1;
  if (!giftVariant || ((!aProduct && !aVariant) && (!bProduct && !bVariant))) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const endpoint = (suffix) => root.replace(/\/$/, '/') + 'cart/' + suffix + '.js';
  let busy = false, rerun = false, timer, lastSignature = '', failUntil = 0;
  const cartUrl = root.replace(/\/$/, '/') + 'cart.js';
  const readCart = async () => {
    const res = await fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store' });
    if (!res.ok) throw new Error('Could not read cart');
    return res.json();
  };
  const qtyFor = (cart, product, variant) => cart.items.reduce((sum, item) => {
    if (String(item.variant_id) === giftVariant) return sum;
    return sum + ((variant && String(item.variant_id) === variant) ||
      (product && String(item.product_id) === product) ? item.quantity : 0);
  }, 0);
  const qualifies = cart =>
    ((aProduct || aVariant) && qtyFor(cart, aProduct, aVariant) >= aQty) ||
    ((bProduct || bVariant) && qtyFor(cart, bProduct, bVariant) >= bQty);
  const giftLines = cart => cart.items.filter(item =>
    String(item.variant_id) === giftVariant && String((item.properties || {})._free_gift) === 'true');
  const post = async (path, body) => {
    const res = await fetch(endpoint(path), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Cart update failed');
    return data;
  };
  const sections = () => ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
  function refreshUI(data) {
    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
      return;
    }
    const miniCart = document.querySelector('mini-cart');
    if (miniCart && data.sections) {
      const items = typeof miniCart.getSectionsToRender === 'function'
        ? miniCart.getSectionsToRender()
        : sections().map(id => ({ id, section: id, selector: '.shopify-section' }));
      items.forEach(s => {
        const target = document.getElementById(s.id);
        const html = data.sections[s.section || s.id];
        if (!target || !html) return;
        try {
          target.innerHTML = typeof miniCart.getSectionInnerHTML === 'function'
            ? miniCart.getSectionInnerHTML(html, s.selector) : html;
        } catch (e) { console.warn('[Andara gift] cart render:', e); }
      });
    }
    document.dispatchEvent(new CustomEvent('free-gift:synced', { detail: data }));
  }
  async function sync() {
    if (busy) { rerun = true; return; }
    busy = true;
    try {
      const cart = await readCart();
      const signature = cart.items.map(i => `${i.key}:${i.quantity}`).join('|');
      const lines = giftLines(cart);
      const eligible = !!qualifies(cart);
      if (eligible && lines.length === 0 && Date.now() >= failUntil) {
        const data = await post('add', {
          items: [{ id: Number(giftVariant), quantity: 1,
            properties: { _free_gift: 'true', Offer: 'Free gift' } }],
          sections: sections(), sections_url: window.location.pathname
        });
        refreshUI(data);
      } else if (!eligible && lines.length) {
        for (const line of lines) {
          const data = await post('change', {
            id: line.key, quantity: 0, sections: sections(),
            sections_url: window.location.pathname
          });
          refreshUI(data);
        }
      } else if (eligible && lines.length && (lines.length > 1 || lines[0].quantity !== 1)) {
        for (let i = 0; i < lines.length; i++) {
          const data = await post('change', {
            id: lines[i].key, quantity: i === 0 ? 1 : 0,
            sections: sections(), sections_url: window.location.pathname
          });
          refreshUI(data);
        }
      }
      lastSignature = signature;
    } catch (error) {
      console.warn('[Andara gift]', error);
      failUntil = Date.now() + 30000;
    } finally {
      busy = false;
      if (rerun) { rerun = false; schedule(); }
    }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 350); }
  ['cart:updated', 'ajaxProduct:added', 'cartdrawer:opened', 'page:loaded'].forEach(name =>
    document.addEventListener(name, schedule));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, schedule); } catch (_) {}
  }
  // Catch themes that do not dispatch cart events.
  setInterval(async () => {
    if (busy) return;
    try {
      const cart = await readCart();
      const signature = cart.items.map(i => `${i.key}:${i.quantity}`).join('|');
      if (signature !== lastSignature) schedule();
    } catch (_) {}
  }, 3000);
  schedule();
})();